import { Box } from '@mui/material';
import { useIsAuthenticated } from "@azure/msal-react";

// import { SignInButton } from "../../auth/SignInButton";
import { SignUpSignInButton } from '../../auth/SignUpSignInButton';

export default function PageNotFound() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <Box className="Page PageNotFound">
      <h2 className="np-title">PageNotFound</h2>
      <Box sx={{m: 10, textAlign: 'center'}}>
        {
          isAuthenticated
          ?
            <p>Bummer, we couldn't find that page.</p>
          :
            <SignUpSignInButton label="Maybe Log In First"></SignUpSignInButton>
        }
      </Box>
    </Box>
  );
}
